module.exports = __webpack_public_path__ + "img/1d14031.png";